import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import checkIcon from '../images/check.svg';
import likeIcon from '../images/icon-like.svg';
import './successMsg.scss';

const SuccessMsg = (props) => {
  const isFiberAdd = props.variant === 'fiberAdd';

  return (
    <div className={`payment-cg-success-msg${isFiberAdd ? ' payment-cg-success-msg--fiber' : ''}`}>
      <div className='img-wrapper'>
        <Image
          alt='card-approved'
          src={isFiberAdd ? checkIcon : likeIcon}
        />
      </div>
      <div className='text-wrapper'>
        <p>{isFiberAdd ? 'הכרטיס אושר' : 'הכרטיס מאושר'}</p>
      </div>
    </div>
  );
};

export default SuccessMsg;
